import type { AdapterMeta } from "@repo/adapter-core";

export const REALESTATE_ADAPTER_META: AdapterMeta = {
  slug: "realestate-com-au",
  name: "realestate.com.au",
  baseUrl: "https://www.realestate.com.au",
  description: "Australia's largest property portal. Nationwide sold, buy, and rent listings.",
  supportedStates: ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
  urlPattern:
    /realestate\.com\.au\/(sold\/|buy\/|rent\/)?property-[a-z+]+-[a-z]{2,3}-[a-z+-]+-\d+$/i,
  sourceType: "portal",
};
